import { render, staticRenderFns } from "./LinkModal.vue?vue&type=template&id=58d61fdd"
import script from "./LinkModal.vue?vue&type=script&lang=js"
export * from "./LinkModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports